import { z } from 'zod';
/**
 * What the Sample data page offers (#173), written by
 * apps/api/scripts/gen-sample-data.ts after each weekly load next to the files
 * in the coverage bucket (sample/manifest.json).
 */
export const SAMPLE_FILE_KEYS = ['arizona', 'random10k', 'dictionary'];
export const SampleFile = z.object({
    key: z.enum(SAMPLE_FILE_KEYS),
    format: z.enum(['csv', 'parquet', 'xlsx']),
    /** Object name in the bucket (server-side only; never sent to the browser). */
    object: z.string().optional(),
    /** Download name, e.g. mollusk-arizona-10y-2026-10-24.csv.gz */
    filename: z.string(),
    rows: z.number().int().nullable(),
    bytes: z.number().int().nullable(),
});
export const SampleManifest = z.object({
    generated_at: z.string(),
    files: z.array(SampleFile),
    checks: z.array(z.object({ key: z.string(), label: z.string() })),
    /** Per sample: rows in scope, rows removed, and how many each check flagged. */
    removed: z.record(z.string(), z.object({
        in_scope: z.number(),
        removed: z.number(),
        checks: z.record(z.string(), z.number()),
    })),
});
/** Object name in the bucket for a file. */
export const sampleObject = (prefix, f) => `${prefix}/${f.key}.${f.format === 'csv' ? 'csv.gz' : f.format}`;
//# sourceMappingURL=manifest.js.map